const ProgressBar = ({ percentageFilled }) => {
    return (
        // Full Bar (Gray Background)
        <div className="h-4 rounded-full w-4/5 bg-slate-300 mt-2.5 mb-3.5">
            {/* Filled Part */}
            <div id="progress-bar" className="bg-green-700 h-full rounded-full" style={ { width: `${percentageFilled}%` } }></div>
        </div>
    )
};

export default ProgressBar;